import script from "./TextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextArea.vue?vue&type=script&setup=true&lang=ts"

import "./TextArea.vue?vue&type=style&index=0&id=753d8210&lang=css"

const __exports__ = script;

export default __exports__